module.exports = __webpack_public_path__ + "img/b-pink-s@3x.73881729.png";